import { FC } from 'react';
import { Tooltip } from '@mui/material';
import ProntoLogoExpanded from './ProntoLogoExpanded';
import ProntoLogoIcon from './ProntoLogoIcon';

export interface ProntoLogoProps {
  expanded?: boolean;
  fill?: string;
  height?: number | string;
}

const ProntoLogo: FC<ProntoLogoProps> = ({
  expanded = false,
  fill = 'currentColor',
  height,
}) =>
  expanded ? (
    <ProntoLogoExpanded fill={fill} height={height} />
  ) : (
    <Tooltip title="Pronto Housing" placement="right">
      <span
        role="img"
        aria-label="Pronto Housing"
        style={{ display: 'inline-flex', lineHeight: 0 }}
      >
        <ProntoLogoIcon fill={fill} height={height} />
      </span>
    </Tooltip>
  );

export default ProntoLogo;
